var DefaultVINValue = "Enter VIN";
var cannotLoadAjax = "Can not process your request";
var makeText = 'Make';
var yearText = 'Year';
var modelText = 'Model';
var loadingText = 'Loading';


function validVin() {
    var text = $('#vin').val().toUpperCase();
    text = text.replace(/Q/g, "0").replace(/O/g, "0").replace(/I/g, "1").replace(/[^a-zA-Z0-9]/g, '');
    $('#vin').val(text);
    var vinLength = 17 - $('#vin').val().length;
    $("#vinCount").html(vinLength);
}

function typingEventVIN(e){
  var code = e.keyCode || e.which; 
  if ((code != 8 && code != 13) && (code < 48 || code > 57) && (code < 65 || code > 90) && (code < 97 || code > 122)){
     return false;
   }  
}
 
function getMakes() {    

  var url = "/apps/innova-api/dlc/makes/?r=" + Math.random();

  $.ajax({
    type: "GET",    
    url: url,
    error: function () {
      alert(cannotLoadAjax);
    },
    success: function (data) {
      var result = data.makes;
      var options = "<option value=''>" + makeText + "</option>";
      for (var i = 0; i < result.length; i++) {
        options += '<option value="' + result[i] + '">' + result[i] + '</option>';
      }
      $("select#make").html(options);
      $("select#year").html("<option value=''>" + yearText + "</option>");
      $("select#model").html("<option value=''>" + modelText + "</option>");            
    }
  });
}
  
  function getYears() {
    var sMake = $("#make").val();
    if('' != sMake){ 
     try {
	  var url = "/apps/innova-api/dlc/" + sMake + "/years/?r=" + Math.random();
	  $('#ModalContentAjax').modal("show");
	  $.ajax({
        type: "POST",        
        url: url,
        error: function () {
			$('#ModalContentAjax').modal("hide");
            alert(cannotLoadAjax);
        },
        success: function (data) {
          	var result = data.years;
            var options = "<option value=''>" + yearText + "</option>";
			for (var i = 0; i < result.length; i++) {
				options += '<option value="' + result[i] + '">' + result[i] + '</option>';
			}
			 
			$("select#year").html(options);    
			$("select#model").html("<option value=''>" + modelText + "</option>");
			$('#ModalContentAjax').modal("hide");      
        }
		});	  
	 
     } catch(e) {
	   $('#ModalContentAjax').modal("hide");
     }

    } else {	  
	  $("select#year").html("<option value=''>" + yearText + "</option>");
	  $("select#model").html("<option value=''>" + modelText + "</option>");
      }
  }
  
  function getModels() {    
    var sMake = $("#make").val();
    var sYear = $("#year").val();

    if('' != sMake && '' != sYear){
      try {
	   var url = "/apps/innova-api/dlc/" + sMake + "/" + sYear + "/models/?r=" + Math.random();
	   $('#ModalContentAjax').modal("show");
	   $.ajax({
        type: "POST",        
        url: url,
        error: function () {
			$('#ModalContentAjax').modal("hide");
            alert(cannotLoadAjax);
        },
        success: function (data) {
          	var result = data.models;
            var options = "<option value=''>" + modelText + "</option>";
			for (var i = 0; i < result.length; i++) {
				options += '<option value="' + result[i] + '">' + result[i] + '</option>';
			}
			$("select#model").html(options);
			$('#ModalContentAjax').modal("hide");
		  }
		});	  		
	  
     } catch(e) {
		$('#ModalContentAjax').modal("hide");
     }
    } else {
	  $("select#model").html("<option value=''>" + modelText + "</option>");
      }
  }

  function findDLC() {
    if (validateDLCForm()) {
		var vin = $("#vin").val();
		if (vin != "" && vin != "VIN") {
			if (vin.length < 17) {
				$("#vin").parent().addClass("w-error");
				return false;
			}
			getDLCByVin();
		}
		else {
			 getDLCByMYM();
		}
	}
		
  }

  function validateDLCForm() {
    $("#year").parent().removeClass("w-error");
    $("#make").parent().removeClass("w-error");
    $("#model").parent().removeClass("w-error");
    $("#vin").parent().removeClass("w-error");

      if ($("#vin").val() == "") {
          $("#year").addClass("required");
          $("#make").addClass("required");
          $("#model").addClass("required");

          $("#vin").removeClass("required");
      } else {
          $("#year").removeClass("required");
          $("#make").removeClass("required");
          $("#model").removeClass("required");
          
          $("#vin").addClass("required");
      }

      if(!checkRequiredFields('formDLC')){
        return false;
      }
    
      return true;
  }

  
  function getDLCByVin() {
   $("#errorMessage").hide();
   var sVin = $("#vin").val();
      
	  $('#ModalContentAjax').modal("show");
	  showConnectorImage();
        
      var url = "/apps/innova-api/dlc/" + sVin + "/location/?r=" + Math.random();	  
	  $.ajax({
        type: "GET",        
        url: url,
        error: function () {
			$('#ModalContentAjax').modal("hide");
          	grecaptcha.reset(0);
            alert(cannotLoadAjax);
        },
        success: function (data) {
          if(!data.message.success){
            $("#contentSearchVehicleInfo").hide();
            $("#errorMessage").html(' ')
            $("#errorMessage").html((data.message.code != 3006) ? data.message.description : "Sorry, could not get DLC! Please contact admin.")
            $("#errorMessage").show();
          }else{
	       
    		$("#dlcYear").text(data.year);
            $("#dlcLocation").text(data.locationNumber);
            $("#dlcAccess").text(data.access);
            $("#dlcComments").text(data.comments);
            if (data.imageFileUrl != "") {
              $("#connectorImage").attr("src", data.imageFileUrl);
              $("#connectorImage").show();
            }
            else {
              $("#connectorImage").attr("src", "");
            }
            var src =  data.dlcLocationResourceUrl + "/Dlc/Position/" + data.locationNumber + ".jpg";
            $("#connectorPositionImage").attr("src",src);
            $("#connectorPositionImage").show();

            $("#contentSearchVehicleInfo").show();            
	       
            $("img").on("error", function() {
              $(this).hide();                
            });

          }
          
          $('#ModalContentAjax').modal("hide");  
          grecaptcha.reset(0);
          $("#captcharDiv").hide();
        }
	  });	  
  }
  
  function getDLCByMYM() {
   $("#errorMessage").hide();
   var message = '';
    var sMake = $("#make").val();
    var sYear = $("#year").val();
    var sModel = $("#model").val();
    
    if ('' == sMake) {
	message = "Please select a make";
    }
    else if ('' == sYear) {
	message = "Please select a year";
    }
    else if ('' == sModel) {
	message = "Please select a model";
    }
    
    $("#errorDLC").text(message);
    if (message.length > 0) {
	return;
    }    
   
    $('#ModalContentAjax').modal("show");
    var url = "/apps/innova-api/dlc/" + sMake + "/"+ sYear +"/"+ sModel +"/location/?r=" + Math.random();
	  
	  $.ajax({
        type: "POST",        
        url: url,
        error: function () {
			$('#ModalContentAjax').modal("hide");
          	grecaptcha.reset(0);
            alert(cannotLoadAjax);
        },
        success: function (data) {
          if(!data.message.success){
            $("#contentSearchVehicleInfo").hide();            
            $("#errorMessage").html((data.message.code != 3006) ? data.message.description : "Sorry, counld not get DLC! Please contact admin.")
            $("#errorMessage").show();
          }else{
	       
    		$("#dlcYear").text(data.year);
            $("#dlcLocation").text(data.locationNumber);
            $("#dlcAccess").text(data.access);
            $("#dlcComments").text(data.comments);
            if (data.imageFileUrl != "") {
              $("#connectorImage").attr("src", data.imageFileUrl);
              $("#connectorImage").show();
            }
            else {
              $("#connectorImage").attr("src", "");
            }
            var src =  data.dlcLocationResourceUrl + "/Dlc/Position/" + data.locationNumber + ".jpg";
            $("#connectorPositionImage").attr("src",src);
            $("#connectorPositionImage").show();

            $("#contentSearchVehicleInfo").show();            
	       
			      $("img").on("error", function() {
              $(this).hide();                
            });
            
          }
          
          $('#ModalContentAjax').modal("hide");  
          grecaptcha.reset(0);
          $("#captcharDiv").hide();
        }
	});	  
    
  }

  document.addEventListener('DOMContentLoaded', function() {  
	  getMakes();  
    $('#vin').attr("maxlength", 17);
  
    $('#vin').keypress(function (event) {
        return typingEventVIN(event);
    });
    
    $('#vin').keydown(function (event) {
      if (event.keyCode == 13) {
        var vin = $("#vin").val();
        if (vin != "" && vin != "VIN") {
          if (vin.length < 17) {
            $("#vin").parent().addClass("w-error");
            alert("Invalid Vin number");
            return false;
          } else {
            getDLCByVin();
          }
        }
      }
    });

    $("#vin").change(function () {
      validVin();
    });

    $("#vin").blur(function () {
      validVin();        
    });

    $('#vin').keyup(function (event) {
      if (event.keyCode != 13) {
        var vinLength = 17 - $('#vin').val().length;
        $("#vinCount").html(vinLength);
      }
    });

    $("#make").change(function () {
      getYears();
    });

    $("#year").change(function () {
      getModels();
    });

    $('form#formDLC').on('submit', function(e){
      e.preventDefault();
    });

    $("#make").val("");
    $("#contentSearchVehicleInfo").hide();      
   
    var captchaKey = $("#GoogleCaptchaKey").val();
    $("div.g-recaptcha").attr("data-sitekey", captchaKey);  
  
    //Captchar
  	$("#captcharDiv").hide();    
    
    $("#findDlcBtn").click(function(){
        var numberOfClicksCookie = getCookie("dlc-search-times");
   		var numberOfClicks =  numberOfClicksCookie != undefined && numberOfClicksCookie != null ? JSON.parse(numberOfClicksCookie) : [];    
 
        if(numberOfClicks.length < queryCount){
           numberOfClicks.push(new Date().getTime());
           setCookie("dlc-search-times", JSON.stringify(numberOfClicks), 0);
           findDLC();           
        }else{         
            var diff = numberOfClicks[numberOfClicks.length -1] - numberOfClicks[0] ;            
            if(diff < captInMiliSecond){ //15s
              $('#re-captcha').show();             
			  grecaptcha.reset(0);
              $("#captcharDiv").show();                 
            }else{
            	numberOfClicks.shift();
            	numberOfClicks.push(new Date().getTime());    
                
                setCookie("dlc-search-times", JSON.stringify(numberOfClicks), 0);
           		findDLC();                
             }          
            
            
        }
    });
    

  });

  function showConnectorImage()
  {
	  $("#connectorImage").show();
      $("#connectorPositionImage").show();
  }
 
var actCallback = function (response) {
  findDLC();
  $("#captcharDiv").hide();

};
var expCallback = function() {
  grecaptcha.reset(0);
  setTimeout(function(){
    grecaptcha.reset(0);
  }, 30000);
};

var onloadCallback = function () {
  var captchaKey = $("#GoogleCaptchaKey").val();
  var widget = grecaptcha.render(document.getElementById("re-captcha"), {
    'sitekey' : captchaKey, // Sitekey, Retrieving from reCaptcha
    'theme': "light",
    'callback' : actCallback,
    'expired-callback': expCallback,
  });
}

